/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Link } from '../../models/link';

export interface LinksControllerDeleteImage$Params {
  id: string;
}

export function linksControllerDeleteImage(http: HttpClient, rootUrl: string, params: LinksControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Link>> {
  const rb = new RequestBuilder(rootUrl, linksControllerDeleteImage.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Link>;
    })
  );
}

linksControllerDeleteImage.PATH = '/links/{id}/image';
